export default __webpack_public_path__ + "static/media/console_dark.436ab49d.png";